module.exports = __webpack_public_path__ + "files/2a1a29413832600e9c29ac5331b45adf.png";